import { useCallback } from 'react';
import type { BirthDatePickerSelectOption } from '../BirthDatePicker';

export const useStartsWithFilter = () =>
  useCallback(
    (input: string, option?: BirthDatePickerSelectOption) =>
      Boolean(option?.label.toLowerCase().startsWith(input.toLowerCase())),
    [],
  );
